import React from "react";

function Footer() {
  return (
    <div className="footer container-fluid">
      <div className="container">
        <p className="connect-text">Connect with me</p>
        <div className="flex-icon">
          <a href="https://www.facebook.com/taufik.nurrahman.980">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
            >
              <path
                d="M31.6253 13.4168V14.7585C32.3663 14.7585 32.967 14.1578 32.967 13.4168H31.6253ZM31.6253 5.75012H32.967C32.967 5.00914 32.3663 4.40846 31.6253 4.40846V5.75012ZM18.2087 21.0835V22.4251C18.9496 22.4251 19.5503 21.8244 19.5503 21.0835H18.2087ZM12.459 21.0835V19.7418C11.718 19.7418 11.1173 20.3425 11.1173 21.0835H12.459ZM12.459 28.7501H11.1173C11.1173 29.4911 11.718 30.0918 12.459 30.0918V28.7501ZM18.2087 28.7501H19.5503C19.5503 28.0091 18.9496 27.4085 18.2087 27.4085V28.7501ZM18.2087 40.2501H16.867C16.867 40.9911 17.4677 41.5918 18.2087 41.5918V40.2501ZM25.8753 40.2501V41.5918C26.6163 41.5918 27.217 40.9911 27.217 40.2501H25.8753ZM25.8753 28.7501V27.4085C25.1343 27.4085 24.5337 28.0091 24.5337 28.7501H25.8753ZM30.6673 28.7501V30.0918C31.283 30.0918 31.8196 29.6728 31.9689 29.0755L30.6673 28.7501ZM32.584 21.0835L33.8856 21.4089C33.9858 21.008 33.8957 20.5834 33.6415 20.2578C33.3872 19.9321 32.9971 19.7418 32.584 19.7418V21.0835ZM25.8753 21.0835H24.5337C24.5337 21.8244 25.1343 22.4251 25.8753 22.4251V21.0835ZM26.8337 12.0751C25.5634 12.0751 24.5337 13.1049 24.5337 14.3751H27.217C27.217 14.5868 27.0454 14.7585 26.8337 14.7585V12.0751ZM31.6253 12.0751H26.8337V14.7585H31.6253V12.0751ZM30.2837 5.75012V13.4168H32.967V5.75012H30.2837ZM26.8337 7.09179H31.6253V4.40846H26.8337V7.09179ZM19.5503 14.3751C19.5503 10.3526 22.8112 7.09179 26.8337 7.09179V4.40846C21.3292 4.40846 16.867 8.87068 16.867 14.3751H19.5503ZM19.5503 21.0835V14.3751H16.867V21.0835H19.5503ZM12.459 22.4251H18.2087V19.7418H12.459V22.4251ZM13.8007 28.7501V21.0835H11.1173V28.7501H13.8007ZM18.2087 27.4085H12.459V30.0918H18.2087V27.4085ZM19.5503 40.2501V28.7501H16.867V40.2501H19.5503ZM25.8753 38.9085H18.2087V41.5918H25.8753V38.9085ZM24.5337 28.7501V40.2501H27.217V28.7501H24.5337ZM30.6673 27.4085H25.8753V30.0918H30.6673V27.4085ZM31.2824 20.7581L29.3657 28.4247L31.9689 29.0755L33.8856 21.4089L31.2824 20.7581ZM25.8753 22.4251H32.584V19.7418H25.8753V22.4251ZM24.5337 14.3751V21.0835H27.217V14.3751H24.5337Z"
                fill="#F8E7A1"
                fillOpacity="0.92"
              />
            </svg>
          </a>
          <a href="https://www.instagram.com/taunur_">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
            >
              <rect
                x="6.70801"
                y="6.70801"
                width="32.5833"
                height="32.5833"
                rx="7.66667"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinejoin="round"
              />
              <circle
                cx="23.0003"
                cy="23.0003"
                r="6.70833"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinejoin="round"
              />
              <circle
                cx="31.1458"
                cy="12.9378"
                r="2.39583"
                fill="#F8E7A1"
                fillOpacity="0.92"
              />
            </svg>
          </a>
          <a href="https://www.linkedin.com/in/taunur">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
            >
              <rect
                x="6.70703"
                y="6.70801"
                width="32.5833"
                height="32.5833"
                rx="3.83333"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinejoin="round"
              />
              <path
                d="M15.332 20.125V31.625"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.082 19.167V31.6253"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle
                cx="15.3337"
                cy="14.3747"
                r="1.91667"
                fill="#F8E7A1"
                fillOpacity="0.92"
              />
              <path
                d="M21.082 24.9167L21.4241 23.2066C21.7824 21.4148 23.3557 20.125 25.1829 20.125H26.832C28.9491 20.125 30.6654 21.8412 30.6654 23.9583V31.625"
                stroke="#F8E7A1"
                strokeOpacity="0.92"
                strokeWidth="2.68333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a href="https://github.com/taunur">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
            >
              <path
                d="M11.603 34.2796C10.1679 32.4246 9.74268 31.8191 9.41542 31.2259L9.34717 31.0981C9.27438 30.9672 9.2032 30.8353 9.13366 30.7026C9.04339 30.5318 8.96162 30.3566 8.88865 30.1776C8.58414 29.4216 8.52639 28.7549 9.01115 28.1389C9.85994 27.0539 11.239 27.3602 12.401 28.3542C13.1501 28.9929 14.2666 30.1391 14.9474 30.9546C15.3937 31.4884 16.2074 32.0414 16.8025 32.2391C16.8597 32.2585 16.9182 32.2743 16.9775 32.2863L17.289 31.3064C16.1234 30.9031 15.0218 30.3344 14.0181 29.6176C11.743 27.9797 9.76543 24.765 9.93519 22.3132C10.0402 20.7645 10.5652 19.2455 11.4928 17.7703C11.415 17.0507 11.3723 16.3277 11.365 15.6039C11.365 14.7481 11.645 13.8189 12.1823 12.7986C12.278 12.6174 12.4202 12.4649 12.5942 12.3567C12.7683 12.2484 12.9679 12.1884 13.1728 12.1827C14.1143 12.1528 15.0553 12.2529 15.9694 12.4802C16.7657 12.6814 17.6075 13.0349 18.4983 13.5389C19.8318 13.2624 21.1234 13.1224 22.3764 13.1224C23.6312 13.1224 24.9368 13.2624 26.2948 13.5406C27.4534 12.8914 28.4719 12.4504 29.3609 12.2194C30.516 11.9202 31.5555 12.0094 32.4113 12.5379C32.5292 12.6109 32.6329 12.7046 32.7176 12.8144C33.2426 13.4934 33.5331 14.3946 33.6276 15.5059C33.7011 16.3528 33.6749 17.1946 33.5489 18.0293C34.3066 19.1685 34.8001 20.6245 35.0434 22.3867C35.4389 25.2637 34.1246 28.2264 32.0368 29.9326C31.0638 30.7271 29.7267 31.3501 28.0221 31.8226C28.1306 32.2006 28.2076 32.5768 28.2531 32.9531C28.3301 33.5726 28.3844 35.2351 28.4212 38.0105C30.3497 37.006 31.846 36.0155 32.9101 35.0443C34.7214 33.3941 36.0864 31.0526 36.9755 28.3332C37.7193 26.0582 37.8628 24.1385 37.4953 22.0228C37.0455 19.4503 36.398 17.3521 35.4232 15.6686C34.2821 13.6981 32.4621 11.8362 30.285 10.4747C28.2024 9.1692 24.8248 8.29596 22.1647 8.29596C19.3716 8.29596 16.2459 9.2007 13.8746 10.8737C11.568 12.5012 9.65693 14.9511 8.54914 17.3538C7.67235 19.2578 7.31184 21.286 7.31184 24.2802C7.31184 26.7057 8.19387 29.6526 9.23341 31.4971C10.0542 32.9531 11.2197 34.3321 12.9331 35.83C13.7958 36.586 15.0156 37.3403 16.5907 38.0858V37.3455C14.4819 36.8555 12.8053 35.8335 11.603 34.2796ZM10.9782 29.1661C10.9783 29.1632 10.9783 29.1603 10.9782 29.1574V29.1661ZM13.4371 32.8796C14.4346 34.1728 15.9064 34.9656 17.9172 35.2596C18.1906 35.2994 18.4405 35.4363 18.6214 35.6451C18.8023 35.8539 18.9021 36.1208 18.9025 36.397V39.8497C18.9015 40.0392 18.8539 40.2255 18.7638 40.3922C18.6738 40.559 18.5441 40.701 18.3863 40.8058C18.2284 40.9106 18.0472 40.9749 17.8585 40.9931C17.6699 41.0113 17.4797 40.9829 17.3047 40.9102C14.7234 39.8497 12.7598 38.7402 11.4052 37.5555C9.50467 35.893 8.17287 34.3146 7.21559 32.6206C5.99404 30.4489 5 27.1257 5 24.2785C5 20.9798 5.41652 18.6348 6.44731 16.3983C7.71435 13.6474 9.87569 10.8789 12.5375 9.0012C15.3149 7.04123 18.9078 6 22.1612 6C25.2413 6 29.0442 6.98348 31.5153 8.53046C34.0074 10.0914 36.0934 12.2247 37.4235 14.5224C38.5593 16.4806 39.2803 18.8151 39.7703 21.6308C40.2044 24.1175 40.0329 26.4152 39.1736 29.0419C38.169 32.1096 36.6062 34.7906 34.4729 36.7365C32.9293 38.1435 30.6997 39.5207 27.7754 40.8892C27.6005 40.9719 27.4077 41.0093 27.2145 40.998C27.0214 40.9868 26.8342 40.9272 26.6701 40.8248C26.5061 40.7224 26.3703 40.5804 26.2754 40.4118C26.1804 40.2433 26.1294 40.0536 26.1268 39.8602C26.0918 36.0995 26.0341 33.8508 25.9571 33.2313C25.8765 32.6306 25.701 32.0464 25.4373 31.5006C25.3639 31.3439 25.327 31.1726 25.3293 30.9996C25.3315 30.8266 25.373 30.6563 25.4504 30.5016C25.5279 30.3469 25.6393 30.2117 25.7765 30.1062C25.9136 30.0007 26.0729 29.9276 26.2423 29.8924C28.2444 29.4671 29.6865 28.8774 30.565 28.1599C32.0613 26.9367 33.0326 24.7475 32.7508 22.7C32.5268 21.0795 32.0735 19.8545 31.4138 19.0111C31.3121 18.8816 31.2396 18.7317 31.2012 18.5716C31.1629 18.4115 31.1596 18.245 31.1915 18.0836C31.349 17.2961 31.3928 16.5033 31.3228 15.7001C31.2738 15.1296 31.1618 14.6991 31.0025 14.4016C30.7487 14.3176 30.4057 14.3211 29.942 14.4419C29.1894 14.6361 28.2269 15.0719 27.0719 15.7456C26.8175 15.8948 26.516 15.9417 26.2283 15.8768C24.9646 15.5827 23.6721 15.4295 22.3747 15.4201C21.1619 15.4201 19.8896 15.5706 18.5613 15.8751C18.2672 15.9425 17.9584 15.893 17.7002 15.7369C16.8427 15.2189 16.0727 14.8759 15.4007 14.7079C14.9281 14.5889 14.4381 14.5154 13.9358 14.4874C13.7591 14.9266 13.6733 15.2994 13.6733 15.6039C13.6733 16.2023 13.7258 16.9793 13.8308 17.9278C13.8605 18.1971 13.7935 18.4681 13.6418 18.6926C12.7878 19.9595 12.3258 21.2143 12.24 22.4707C12.1315 24.0195 13.6856 26.5429 15.3726 27.7574C16.4139 28.5082 17.6337 29.0699 19.0355 29.4409C19.1859 29.4802 19.3267 29.5496 19.4495 29.645C19.5722 29.7403 19.6743 29.8596 19.7496 29.9956C19.8248 30.1315 19.8717 30.2814 19.8874 30.436C19.903 30.5906 19.8871 30.7468 19.8406 30.8951L18.9603 33.6723C18.9077 33.8378 18.8183 33.9892 18.6989 34.1153C18.5795 34.2414 18.4331 34.3388 18.2708 34.4003C17.569 34.6663 16.8182 34.6663 16.0657 34.4178C15.0646 34.0853 13.8886 33.2856 13.1658 32.4211C12.9651 32.1827 12.7586 31.9493 12.5463 31.7211C12.7843 32.0361 13.0766 32.4141 13.4371 32.8796Z"
                fill="#F8E7A1"
              />
            </svg>
          </a>
        </div>
        <p className="connect-text">
          © 2023 Copyright Website Portofolio. All Rights Reserved | Design By:
          Taunur
        </p>
      </div>
    </div>
  );
}

export default Footer;
